var map = {
	"./content-deco-1.webp": 1471,
	"./content-deco-2.webp": 1472,
	"./deposit-icon.webp": 1473,
	"./home-icon-active.webp": 1474,
	"./home-icon.webp": 1475,
	"./live-icon-active.webp": 1476,
	"./live-icon.webp": 1477,
	"./me-icon-active.webp": 1478,
	"./me-icon.webp": 1479,
	"./product-overview-bg.webp": 1480,
	"./promos-icon-active.webp": 1481,
	"./promos-icon.webp": 1482,
	"./services-bg.webp": 1483,
	"./sponsor-icon-active.webp": 1484,
	"./sponsor-icon.webp": 1485,
	"./vip-icon.webp": 1486,
	"./withdraw-icon.webp": 1487,
	"./wwr-img.webp": 1488
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 172;